const { VUE_APP_API_URL, VUE_APP_HEALTH_URL, VUE_APP_ALLOWED_GAMES } = process.env;

const API_BASE_URL = VUE_APP_API_URL;
const HEALTH_URL = VUE_APP_HEALTH_URL;
const ALLOWED_GAMES = JSON.parse(VUE_APP_ALLOWED_GAMES);

export * as ENDPOINTS from './endpoints';

export { API_BASE_URL, HEALTH_URL, ALLOWED_GAMES };
